import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {useFormikContext} from "formik";
import classNames from "classnames";

/**
 * FormButton renders a button for a shared portal form, with conveniences like handling loading state automatically.
 */
const FormButton = ({children, onClick, style, submitText}) => {
  const {isSubmitting} = useFormikContext();
  const [clicked, setClicked] = useState(false);

  // use isSubmitting to determine when action is done submitting
  useEffect(() => {
    if (!isSubmitting) {
      setClicked(false);
    }
  }, [isSubmitting]);

  return (
    <div className="col">
      <button
        type="button"
        onClick={() => {
          setClicked(true);
          return onClick();
        }}
        className={classNames("btn", `btn-${style}`)}
        disabled={isSubmitting}
      >{clicked && isSubmitting ? submitText : children}</button>
    </div>
  );
};

FormButton.defaultProps = {
  submitText: "Saving...",
  style: "primary"
};

FormButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  style: PropTypes.string,
  submitText: PropTypes.string,
};

export default FormButton;
